import { isProfessionalActive } from '@/helpers/professionalStatus'

export function createProfessionalFilters() {
  return {
    name: '',
    council: '',
    credential: '',
    status: 'all',
    birthDateFrom: '',
    birthDateTo: '',
    email: '',
    specialties: [],
    createdAtFrom: '',
    createdAtTo: '',
  }
}

function normalizeText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('pt-BR')
}

function matchesText(value, query) {
  return !query || normalizeText(value).includes(normalizeText(query))
}

function dateOnly(value) {
  if (!value) return ''
  return String(value).slice(0, 10)
}

function isDateWithinRange(value, from, to) {
  const currentDate = dateOnly(value)
  if (!from && !to) return true
  if (!currentDate) return false
  if (from && currentDate < from) return false
  if (to && currentDate > to) return false
  return true
}

function hasSelectedSpecialty(professional, selectedSpecialties) {
  if (!selectedSpecialties.length) return true

  const professionalSpecialties = Array.isArray(professional.specialty)
    ? professional.specialty
    : []

  return selectedSpecialties.some((selected) => professionalSpecialties.some((specialty) => (
    String(specialty.id) === String(selected.id)
    || normalizeText(specialty.name) === normalizeText(selected.name)
  )))
}

export function matchesProfessionalFilters(professional, filters) {
  const currentFilters = { ...createProfessionalFilters(), ...filters }
  const selectedSpecialties = Array.isArray(currentFilters.specialties)
    ? currentFilters.specialties
    : []

  if (!matchesText(professional.name, currentFilters.name)) return false
  if (!matchesText(professional.council, currentFilters.council)) return false
  if (!matchesText(professional.credential, currentFilters.credential)) return false
  if (!matchesText(professional.email, currentFilters.email)) return false

  if (currentFilters.status === 'active' && !isProfessionalActive(professional)) return false
  if (currentFilters.status === 'inactive' && isProfessionalActive(professional)) return false

  if (!isDateWithinRange(
    professional.birth_date,
    currentFilters.birthDateFrom,
    currentFilters.birthDateTo,
  )) return false

  if (!isDateWithinRange(
    professional.created_at,
    currentFilters.createdAtFrom,
    currentFilters.createdAtTo,
  )) return false

  return hasSelectedSpecialty(professional, selectedSpecialties)
}
